import { render, staticRenderFns } from "./editpass.vue?vue&type=template&id=19eba8f3"
import script from "./editpass.vue?vue&type=script&lang=js"
export * from "./editpass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports